import { render, staticRenderFns } from "./forgetPwd.vue?vue&type=template&id=5640e261&scoped=true"
import script from "./forgetPwd.vue?vue&type=script&lang=js"
export * from "./forgetPwd.vue?vue&type=script&lang=js"
import style0 from "./forgetPwd.vue?vue&type=style&index=0&id=5640e261&prod&lang=less&scoped=true"
import style1 from "./forgetPwd.vue?vue&type=style&index=1&id=5640e261&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5640e261",
  null
  
)

export default component.exports